module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.modalVisible === 'delete-step') ? _c('layout-general', {
    on: {
      "close": function($event) {
        return _vm.modalClose()
      }
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('general.actions.delete')) + " " + _vm._s(_vm.$t('general.labels.step')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('h4', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('modal.delete_step.are_you_sure')))])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        return _vm.stepRemove()
      }
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.$t('modal.delete_step.yes')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.modalClose()
      }
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))])])])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-d8474780!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/DeleteStep.vue
 ** module id = 912
 ** module chunks = 1
 **/